import type { TranslationKeys } from "./en"

export const zh: TranslationKeys = {
  // App
  appName: "DevPulse",

  // Navigation
  navDashboard: "仪表板",
  navContributors: "贡献者",
  navTeams: "团队",
  navRepositories: "代码库",

  // Views
  viewOrganization: "组织",
  viewGroup: "小组",
  viewIndividual: "个人",
  viewSelectPlaceholder: "选择视图",

  // Common
  loading: "正在加载数据...",
  authenticating: "正在验证...",
  loadingError: "数据加载错误",
  authError: "身份验证错误",
  retry: "重试",
  tryAgain: "再试一次",
  profile: "个人资料",
  settings: "设置",
  logout: "退出登录",
  selectTimeRange: "选择时间范围",
  selectTeam: "选择团队...",
  selectDeveloper: "选择开发者...",
  normalizedView: "归一化",
  absoluteView: "绝对值",

  // Time ranges
  timeLast7Days: "最近7天",
  timeLast14Days: "最近2周",
  timeLast28Days: "最近4周",
  timeLast8Weeks: "最近8周",
  timeLast12Weeks: "最近12周",
  timeLast30Days: "最近30天",
  timeAll: "全部",

  // Dashboard titles
  dashboardOrganizationTitle: "组织仪表板",
  dashboardOrganizationSubtitle: "所有存储库和团队成员的开发指标概览",
  dashboardTeamTitle: "团队仪表板",
  dashboardTeamSubtitle: "{team}团队成员的开发指标",
  dashboardTeamSubtitleGeneric: "团队成员的开发指标",
  dashboardTeamNoData: "未配置团队。请添加团队数据以查看特定团队指标。",
  dashboardIndividualTitle: "个人仪表板",
  dashboardIndividualSubtitle: "{author}的开发指标",
  dashboardIndividualSubtitleGeneric: "个人贡献者的开发指标",
  dashboardIndividualNoData: "未找到作者。请加载数据以查看个人指标。",

  // Contributors page
  contributorsTitle: "贡献者",
  contributorsSubtitle: "分析贡献者的表现和活动",
  contributorsNoData: "所选时间范围内没有可用的贡献者数据。",

  // Teams page
  teamsTitle: "团队",
  teamsSubtitle: "分析团队的表现和活动",
  teamsNoData: "所选时间范围内没有可用的团队数据。",

  // Repositories page
  repositoriesTitle: "代码库",
  repositoriesSubtitle: "分析代码库的表现和活动",
  repositoriesNoData: "所选时间范围内没有可用的代码库数据。",
  repositoriesScoreTitle: "代码库提交复杂度评分",
  repositoriesScoreDescription: "每个代码库所有提交的总复杂度评分。",
  repositoriesPRsTitle: "代码库拉取请求",
  repositoriesPRsDescription: "每个代码库已合并的拉取请求数量。",

  // DORA Metrics page
  doraMetricsTitle: "DORA指标",
  doraMetricsSubtitle: "用于衡量软件交付绩效的DevOps研究与评估(DORA)指标",
  doraMetricsSubtitleTeam: "{team}团队成员的DORA指标",
  doraMetricsSubtitleIndividual: "{author}的DORA指标",
  doraNoDataTitle: "无可用的DORA指标数据",
  doraNoDataDescription: "DORA指标需要发布、拉取请求和提交数据。请确保已收集和导出数据。",
  doraMissingDataTitle: "完整DORA指标所需的缺失数据",
  doraMissingDataDescription: "以下数据点缺失或不完整，无法进行完整的DORA指标计算：",
  doraDataLimitationsTitle: "数据限制",
  doraDataLimitationsDescription: "显示的DORA指标是根据可用数据计算的，存在一些限制：",
  doraOverallPerformance: "总体DORA性能水平",
  doraOverallDescription: "根据四个关键指标，按照DORA基准计算您团队的总体性能水平。",
  doraDeploymentFrequency: "部署频率",
  doraLeadTime: "变更前置时间",
  doraChangeFailureRate: "变更失败率",
  doraTimeToRestore: "服务恢复时间",
  doraPerMonth: "每月",
  doraPerWeek: "每周",
  doraDays: "天",
  doraHours: "小时",
  doraDeploymentsByMonth: "每月部署次数",
  doraDeploymentsByWeek: "每周部署次数",
  doraLeadTimeTrend: "前置时间趋势",
  doraFailureRateTrend: "失败率趋势",
  doraRestoreTimeTrend: "恢复时间趋势",
  doraDeploymentFrequencyDetail: "部署频率随时间变化",
  doraDeploymentFrequencyDetailDescription: "每个周期的部署次数",
  doraLeadTimeDetail: "变更前置时间随时间变化",
  doraLeadTimeDetailDescription: "从PR创建到合并的平均时间（小时）每个周期",
  doraPeriodWeekly: "每周",
  doraPeriodMonthly: "每月",
  doraPeriodSelectLabel: "周期",
  doraMethodologyTitle: "方法论和数据来源",
  doraDeploymentFrequencyMethodology:
    "从发布数据库表中的已发布版本（不包括草稿和预发布版本）计算。",
  doraLeadTimeMethodology: "计算为拉取请求创建和合并之间的时间，从pull_requests表测量。",
  doraChangeFailureRateMethodology:
    "通过检测发布后7天内的错误修复或回滚提交来估计。这是一个近似值，因为我们没有明确的部署失败跟踪。",
  doraTimeToRestoreMethodology:
    "估计为发布和第一次错误修复/回滚提交之间的时间。这是一个近似值，因为我们没有事件管理数据。",

  // DORA Performance Levels
  doraLevelElite: "精英",
  doraLevelHigh: "高",
  doraLevelMedium: "中等",
  doraLevelLow: "低",

  // DORA Missing Data Points
  doraMissingReleases: "部署频率的发布数据",
  doraMissingPullRequests: "交付时间计算的拉取请求数据",
  doraMissingCommits: "故障分析的提交数据",
  doraMissingDeployments: "部署数据（阶段2）- 使用发布作为代理",
  doraMissingWorkflowRuns: "CI/CD工作流数据（阶段2）- 管道可见性有限",
  doraMissingIncidents: "事件跟踪数据（阶段3）- 使用错误修复提交作为代理",

  // DORA Partial Metrics Notice
  doraPartialMetricsTitle: "部分DORA指标",
  doraPartialMetricsDescription:
    "这些指标是使用可用数据（发布、拉取请求和提交）计算的。要获得更准确的指标，需要GitHub Actions工作流运行和事件跟踪数据。",
  doraEstimatedBadge: "估算值",
  doraAccurateBadge: "准确值",
  doraDataQualityEstimated: "使用代理数据进行计算",
  doraDataQualityAccurate: "使用实际部署和事件数据",
  doraNoDataAvailable: "此指标没有可用数据",

  error: "错误",

  // Tabs
  tabPerformance: "性能",
  tabScore: "评分",
  tabPRs: "拉取请求",
  tabIssues: "问题",
  tabActivity: "活动",
  tabReleases: "发布",
  tabStaffing: "人员配置",

  // Staffing tab
  staffingTitle: "团队人员配置概览",
  staffingDescription: "每个团队的成员数量，按团队规模排序。",
  staffingMemberCount: "{count} 成员",
  staffingMember: "{count} 成员",

  // Activity
  recentActivity: "最近活动",

  // Releases tab
  releasesTitle: "发布（最近12周）",
  releasesDescription: "所有代码库中发布的版本总数",
  releasesChartTitle: "按代码库的发布（最近6周）",
  releasesChartDescription: "每个代码库的每周发布活动",

  // Performance tab
  performanceScoreTitle: "综合性能评分（0-100）",
  performanceScoreDescription:
    "综合指标，结合了代码质量（30%）、交付吞吐量（25%）、代码影响（20%）、问题解决（15%）和工作多样性（10%）。",
  performanceScoreAverage: "平均值：{value}",
  performanceScoreComparison: " — 百分比显示每个贡献者与此平均值的比较。",

  performanceScoreTeamTitle: "团队综合性能评分（0-100）",
  performanceScoreTeamDescription:
    "汇总的性能评分，结合所有团队成员在代码质量、交付吞吐量、代码影响、问题解决和工作多样性方面的贡献。",

  // Score tab
  scoreTitle: "提交复杂度评分",
  scoreDescription:
    "根据更改的文件、修改的行数、函数更改和圈复杂度来衡量代码复杂度。较高的分数表示更具挑战性和影响力的贡献。",
  scoreAverage: "平均值：{value}分",
  scoreComparison: " — 百分比显示每个贡献者与此平均值的比较。",

  scoreTeamTitle: "团队提交复杂度评分",
  scoreTeamDescription:
    "所有团队成员提交的综合复杂度评分，衡量代码更改的技术挑战和影响。较高的分数表示更复杂和更有影响力的工作。",

  // PRs tab
  prsTitle: "已合并的拉取请求",
  prsDescription:
    "成功合并的拉取请求总数。此指标反映了代码审查参与度、协作和功能及修复的成功交付。",
  prsAverage: "平均值：{value}个拉取请求",
  prsComparison: " — 百分比显示每个贡献者与此平均值的比较。",

  prsTeamTitle: "团队已合并的拉取请求",
  prsTeamDescription:
    "所有团队成员合并的拉取请求总数。这反映了团队协作、代码审查参与度和功能及修复的成功交付。",

  // Performance tab - Insight cards
  insightMergedPRs: "已合并的拉取请求",
  insightPRThroughput: "拉取请求吞吐量",
  insightFeatureCommits: "功能提交",
  insightFeatures: "功能",
  insightBugfixCommits: "修复提交",
  insightBugfixes: "修复",
  insightMaintenanceCommits: "维护提交",
  insightMaintenance: "维护",

  // Chart titles
  chartCommitsByClassification: "按分类统计的提交",
  chartCommitsBySize: "按大小统计的提交",
  chartRepositoryCommits: "按仓库统计的提交",
  chartRepositoryPRsAndCommits: "按仓库统计的PR和提交",
  chartRepositoryPRsAndCommitsDesc: "在{timeRange}内每个仓库的拉取请求和提交数量",
  chartRepositoryCommitsDesc: "在{timeRange}期间每个仓库的提交数量",
  chartCommitScoresByWeek: "每周提交评分",
  chartCommitScoresByWeekDesc: "按周分组并按大小堆叠的提交复杂度总分",
  chartCommitScoresByClassificationWeek: "按分类的每周提交评分",
  chartCommitScoresByClassificationWeekDesc: "按周分组并按分类堆叠的提交复杂度总分",
  chartPRsMerged: "本月合并的拉取请求",
  chartPRsMergedByWeek: "每周合并的拉取请求",
  chartPRsMergedByWeekDesc: "最近6周每周合并的拉取请求数量",
  chartCodeChanges: "代码更改",
  chartCodeChangesByWeek: "每周代码更改",
  chartCodeChangesByWeekDesc: "每周合并的拉取请求中添加和删除的代码行数",
  chartIssuesCreated: "本月创建的问题",
  chartIssuesClosed: "本月关闭的问题",
  chartActivityTitle: "贡献活动",
  chartActivityDescription: "过去一年内组织范围的活动，包括提交、拉取请求和问题",
  chartDetails: "详情",

  // Chart labels
  linesAdded: "添加的行数",
  linesRemoved: "删除的行数",

  // Language selector
  languageLabel: "语言",
  languageEnglish: "English",
  languageGerman: "Deutsch",
  languageSpanish: "Español",
  languageChinese: "中文",

  // DataTable
  dataTableFilters: "筛选器",
  dataTableFilterBy: "筛选条件：",
  dataTableNoResults: "无结果。",
  dataTableRowsPerPage: "每页行数：",
  dataTablePage: "第",
  dataTableOf: "页，共",
  dataTableTotalRows: "行",
  dataTableSearch: "搜索...",

  // Charts
  chartTrend: "趋势",
  chartDistribution: "分布",
  chartDate: "日期",

  // Quick insights
  quickInsightDate: "最近7天",
  quickInsightVsLastWeek: "对比上周 {count}",
  quickInsightVsLast7Days: "对比前7天 {count}",
  quickInsightVsLast14Days: "对比前14天 {count}",
  quickInsightVsLast28Days: "对比前28天 {count}",
  quickInsightVsLast8Weeks: "对比前8周 {count}",
  quickInsightVsLast12Weeks: "对比前12周 {count}",
  quickInsightVsLastMonth: "对比上月 {count}",

  // Data table column headers
  tableColumnTitle: "标题",
  tableColumnMessage: "消息",
  tableColumnAuthor: "作者",
  tableColumnDate: "日期",
  tableColumnWeekday: "星期",
  tableColumnCreated: "创建时间",
  tableColumnScore: "评分",
  tableColumnFiles: "文件",
  tableColumnAdditions: "+",
  tableColumnDeletions: "-",
  tableColumnType: "类型",
  tableColumnTeam: "团队",
  tableColumnContributor: "贡献者",
  tableColumnValue: "值",
  tableColumnCount: "数量",

  // Chart descriptions
  chartCommitsByClassificationDesc: "按分类（提交类型）分组并按复杂度大小堆叠的提交数量",
  chartCommitsBySizeDesc: "按复杂度大小分组并按分类（提交类型）堆叠的提交数量",
  chartCodeChangesDesc: "合并的拉取请求中添加和删除的代码行数",
  chartPRsMergedDesc: "合并了 {count} 个PR（对比上个周期 {prevCount} 个）",
  chartIssuesCreatedDesc: "创建了 {count} 个问题（对比上个周期 {prevCount} 个）",
  chartIssuesClosedDesc: "关闭了 {count} 个问题（对比上个周期 {prevCount} 个）",

  // Top performers tables
  topTeamsTitle: "顶级团队",
  topContributorsTitle: "顶级贡献者",
  topContributorsTeamMembersLabel: "团队成员",
  topContributorsExternalLabel: "外部贡献者",
  topTeamRepositoriesTitle: "顶级仓库",
  topTeamRepositoriesDescription: "团队贡献最多的仓库",

  // Common labels
  commits: "提交",
  pullRequests: "拉取请求",

  // Settings page
  settingsTitle: "设置",
  settingsSubtitle: "管理应用程序设置和偏好",
  settingsClassificationTitle: "分类",
  settingsClassificationDescription:
    "选择要在图表和指标中包含的提交分类。更改将应用于所有仪表板视图。",
  settingsTeamsTitle: "团队",
  settingsTeamsDescription: "选择要在应用程序中显示的团队。未选择的团队将不会出现在任何视图中。",
  settingsSelectAll: "全选",
  settingsDeselectAll: "取消全选",
  settingsNoTeams: "没有可用的团队。加载数据后，团队将显示在此处。",

  // Classification types
  classificationFeature: "功能",
  classificationBugfix: "错误修复",
  classificationRefactoring: "重构",
  classificationCi: "持续集成/持续部署",
  classificationTests: "测试",
  classificationDocs: "文档",
  classificationChore: "杂务",
  classificationPerf: "性能",
  classificationRevert: "还原",
  classificationMerge: "合并",
  classificationArchive: "归档",
  classificationStyle: "样式",
  classificationOther: "其他",
  classificationUnclassified: "未分类",

  // Search
  searchTeams: "搜索团队...",
  searchContributors: "搜索贡献者...",
  searchRepositories: "搜索仓库...",
  searchCommits: "搜索提交...",
  noSearchResults: "未找到搜索结果。",

  // Commits table
  commitsTableTitle: "所有提交",
  commitsTableDescription: "选定时间范围内所有提交的详细视图",
  tableColumnRepo: "仓库",
  tableColumnClassification: "分类",

  // Performance explanation
  performanceExplanationTitle: "性能评分说明",
  performanceExplanationSubtitle: "了解性能评分的计算方式及其含义",
  performanceMethodologyTitle: "计算方法",
  performanceMethodologyDescription:
    "性能评分是一个综合指标（0-100），结合了开发者贡献的多个维度：",
  performanceQualityWeight: "代码质量 (30%)",
  performanceQualityDesc: "基于提交复杂度评分。更高的复杂度评分表示更具挑战性和影响力的贡献。",
  performanceThroughputWeight: "交付吞吐量 (25%)",
  performanceThroughputDesc: "通过合并的PR和提交频率来衡量。反映交付速度和一致性。",
  performanceImpactWeight: "代码影响 (20%)",
  performanceImpactDesc: "基于代码行数变化（来自提交和PR）。衡量贡献的规模。",
  performanceProblemSolvingWeight: "问题解决 (15%)",
  performanceProblemSolvingDesc: "基于已解决的问题。衡量主动的问题解决和错误修复。",
  performanceVersatilityWeight: "工作多样性 (10%)",
  performanceVersatilityDesc: "基于提交类型分布（功能、错误修复、重构等）。衡量贡献类型的广度。",
  performanceScoreNote:
    "注意：组件达到 100 表示在给定时间段内该维度的最大性能。零值表示该维度没有活动。总分是所有组件的加权平均值。",
  performanceDailyValuesTitle: "每日性能值",
  performanceDailyValuesDescription: "性能评分的每日细分，显示评分如何随时间演变",
  performanceReasoningTooltip: "此评分基于当天的贡献指标计算，包括提交、PR、代码更改和已解决的问题",
  tableColumnReasoning: "推理",

  // Normalized view tooltip
  normalizedViewTooltip:
    "在绝对值和按贡献者标准化的值之间切换。标准化视图显示每个团队成员或仓库贡献者的平均贡献。",
  normalizedViewLabel: "视图模式",
}
